/**
 * Normalize text for accent-insensitive, case-insensitive comparison.
 * Removes diacritics (accents) and converts to lowercase.
 * Example: "Montréal" → "montreal", "François" → "francois"
 */
export function normalize(str) {
  if (!str) return '';
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
